export class FollowupTemplate {
  data: any;
}
